import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiInstagram,
  FiFacebook,
  FiLinkedin,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

const COMPANY_EMAIL = "info@hline.in";
const COMPANY_PHONE = "+91 99749 24190";
const COMPANY_ADDR =
  "Plot No-80/A, Nr. Nayra Petrol Pump. Simada To Canal Road, Surat. 395006";

export default function Footer() {
  return (
    <footer className="bg-transparent relative scroll-mt-24 border-t border-white/10 text-white mt-10">
      <div className="container py-10 flex flex-col gap-10">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 text-sm tracking-wide">
          <div className="max-w-md">
            <img src={logo} alt="MSM Solutions" className="h-10 w-auto" />
            <p className="mt-4 text-white/80 text-sm tracking-wide leading-relaxed">
              Engineering-grade aluminium systems with slim sightlines, acoustic
              comfort and long-term durability — built with ERP, CRM, and
              production intelligence for modern extrusion industries.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.instagram.com/hline_window_facade/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-md bg-white/10 hover:bg-white/20 text-white transition"
              >
                <FiInstagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/people/H-Line-Window-Facade/61555055622228/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-md bg-white/10 hover:bg-white/20 text-white transition"
              >
                <FiFacebook size={18} />
              </a>
              {/* <a
                href="#"
                className="p-2 rounded-md bg-white/10 hover:bg-white/20 text-white transition"
              >
                <FiLinkedin size={18} />
              </a> */}
            </div>
          </div>

          {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-sm tracking-wide flex-1"> */}
          <div>
            <h4 className="font-medium text-white mb-3 uppercase tracking-wider">
              PRODUCTS
            </h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="#products" className="hover:text-white">
                  Windows & Doors
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-white">
                  Louvers & Systems
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-white">
                  Railing Systems
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-white mb-3 uppercase tracking-wider">
              HOME
            </h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="#about" className="hover:text-white">
                  About
                </a>
              </li>
              <li>
                <a href="#process" className="hover:text-white">
                  Process
                </a>
              </li>
              <li>
                <a href="#projects" className="hover:text-white">
                  Projects
                </a>
              </li>
              <li>
                <a href="#reviews" className="hover:text-white">
                  Reviews
                </a>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-white mb-3 uppercase tracking-wider">
              CONTACT US
            </h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-2">
                <FiPhone className="mt-1 shrink-0" />
                <a href={`tel:${COMPANY_PHONE}`} className="hover:text-white">
                  {COMPANY_PHONE}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <FiMail className="mt-1 shrink-0" />
                <a
                  href={`mailto:${COMPANY_EMAIL}`}
                  className="hover:text-white"
                >
                  {COMPANY_EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <FiMapPin className="mt-1 shrink-0" /> {COMPANY_ADDR}
              </li>
            </ul>
          </div>

          {/* <div>
            <h4 className="font-medium text-white mb-3 uppercase tracking-wider">
              TECHNOLOGIES
            </h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="#erp" className="hover:text-white">
                  Extrusion ERP Software
                </a>
              </li>
              <li>
                <a href="#crm" className="hover:text-white">
                  CRM & Customer Portal
                </a>
              </li>
              <li>
                <a href="#production" className="hover:text-white">
                  Production & QC
                </a>
              </li>
              <li>
                <a href="#iot" className="hover:text-white">
                  IoT & Automation
                </a>
              </li>
            </ul>
          </div> */}
        </div>
        {/* </div> */}

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-white/60 text-sm tracking-wide">
          <p>
            © {new Date()?.getFullYear()} MSM Solutions. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-white">
              Privacy
            </Link>
            <Link to="/terms-of-service" className="hover:text-white">
              Terms
            </Link>
            <Link to="/services" className="hover:text-white">
              Services
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
